import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import {
  getAbstractProofsOptions,
  useDeleteAbstractProof,
  useUploadOrUpdateAbstractProof,
} from './model/AbstractProofModel';

interface AbstractProofActionProps {
  abstractId: number;
  authors: Author[];
  variant?: 'compact';
}

export function AbstractProofAction({ abstractId, authors }: AbstractProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getAbstractProofsOptions(abstractId));
  const uploadOrUpdateMutation = useUploadOrUpdateAbstractProof(abstractId);
  const deleteMutation = useDeleteAbstractProof(abstractId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="abstract"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
